import React from 'react';

import './style.scss';

const BlobWrapper = ({ children, ...props }) => {
  return (
    <div
      {...props}
      className="BlobWrapper"
    >
      { children }
    </div>
  );
};

export default BlobWrapper;
